import React, { useState, useEffect, useRef } from 'react'
import styles from './exchangeLand.module.scss'
import { Popup, Tabs, Swiper, Mask, Toast } from 'antd-mobile'
import close from '@/assets/img/landfi/icon_del.png'
import noData from '@/assets/img/landfi/no-data.png'
import ListView from "@/components/AntListView"
import weixuanzhong from '@/assets/img/landfi/wei-xuan-zhong.png'
import xuanzhong from '@/assets/img/landfi/xuanzhong.png'
import { placeLandList, getSystemTime } from '@/api/guland'
import { Title } from './common'
import { StyleMap } from '../dailyTask'
import { residueHours, residue12Hours } from '../utils'
import MyModal from "@/view/landGame/jewelLand/modal";
import TipModal from "./myGyLands/tipsModal/index";

const TabsList = [
  {key: '0', title: 'C级'},
  {key: '1', title: 'B级'},
  {key: '2', title: 'A级'},
]
const TabsListForGold = [
  {key: '2', title: 'A级'},
]

const TabMap = {
  '0': 3,
  '1': 2,
  '2': 1,
}

const ExchangeLand = ({mode,visible, onClose, onConfirm, landId, workApeData, cancelPlace})=>{
  const [currentTab, setCurrentTab] = useState('0')
  const [isChoice, setIsChoice] = useState(false)
  const [confirmVisible, setConfirmVisible] = useState(false)
  const [apeId, setApeId] = useState(null)
  const [currentChooseLand, setCurrentChooseLand] = useState(null)
  const swiperRef = useRef(null)
  const activeTabs = +mode === 3 ? TabsListForGold : TabsList;

  useEffect(() => {
    if (!visible) {
      setCurrentTab('0')
      setIsChoice(false)
    }
    setCurrentTab(+mode === 3 ? '2' : '0')
  }, [visible])

  const choiceItem = (item) => {
    if (item.nftNo === currentChooseLand?.nftNo) {
      setCurrentChooseLand(null)
      setIsChoice(false)
    } else {
      setCurrentChooseLand({...item, separateNo: landId})
      setIsChoice(true)
    }
    setApeId(item.nftNo)
  }

  const onTabClick = (i) => {
    setCurrentTab(i)
    swiperRef.current.swipeTo(i)
  }

  const onSelectConfirm = () => {
    console.log(currentChooseLand)
    onConfirm(currentChooseLand)
    setConfirmVisible(false)
  }

  const handleApeWork = async () => {
    try {
      const res = await getSystemTime()
      if (res.code !== '000000') throw res.msg
      const currentLand = workApeData?.landBlocksDTOList.find((item) => item.separateNo === landId)
      const workApe = currentLand?.lazyMonkeyLayDOList?.length > 0 && currentLand?.lazyMonkeyLayDOList?.some((item) => {
        const { isFirstTime, setTime } = item
        const currentTime = res?.data
        let isWork = null
        if (isFirstTime === 1) {
          if (residue12Hours(setTime) >= 0) {
            const current = Date.parse(currentTime?.replace(/-/g, '/'))
            const set = Date.parse(setTime?.replace(/-/g, '/'))
            const residueTime = 12*60*60*1000 - (current - set)
            if (residueTime > 0) {
              isWork = true
            } else {
              isWork = false
            }
          } else {
            isWork = false
          }
        } else {
          const hours = residueHours(currentTime)
          if (hours < 12) {
            isWork = false
          } else {
            isWork = true
          }
        }
        return isWork
      })
      return workApe
    } catch (error) {
      console.log(error)
      return false
    }
  }
  
  const cancelPlaceHandle = ()=>{
    const ModalInstance = MyModal.show({
      content: (
        <TipModal
          callback={()=>{
            ModalInstance?.close();
            cancelPlace(currentChooseLand)
          }}
          onClose={(flag) => {
            ModalInstance?.close();
          }}
        />
      ),
    });
  }

  return <>
    <Popup 
      visible={visible}
      position='left'
      destroyOnClose
      bodyStyle={{
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        height: '100%',
        background: 'transparent',
        paddingLeft: 0
      }}
    >
      <div className={styles.exchange_land}>
        <Title title="更换土地" className={styles.title}/>
        <div className={styles.exchange_tip}>更换土地将清空打工猴子，不再产生收益</div>
        <div className={styles.close_popup} onClick={onClose}><img src={close} alt="" /></div>
        <div className={styles.tabs_container}>
          <Tabs className={styles.tabs} activeKey={currentTab} onChange={(key) => onTabClick(key)}>
            {activeTabs.map((item, index) => <Tabs.Tab
              key={index} 
              title={<div className={`${styles.tab_title} ${currentTab === item.key ? styles.tab_select: ''}`}>{item.title}</div>}
            ></Tabs.Tab>)}
          </Tabs>
        </div>
        <div className={styles.tabs_content}>
          <Swiper
            direction='horizontal'
            indicator={() => null}
            ref={swiperRef}
            allowTouchMove={false}
            defaultIndex={currentTab}
          >
            <Swiper.Item style={{display: 'flex'}}>
              <LandList focusStatus={currentTab === '0'} type={TabMap[currentTab]} getChooseLand={choiceItem} isChoice={isChoice} apeId={apeId} mode={mode}/>
            </Swiper.Item>
            <Swiper.Item style={{display: 'flex'}}>
              <LandList focusStatus={currentTab === '1'} type={TabMap[currentTab]} getChooseLand={choiceItem} isChoice={isChoice} apeId={apeId} mode={mode}/>
            </Swiper.Item>
            <Swiper.Item style={{display: 'flex'}}>
              <LandList focusStatus={currentTab === '2'} type={TabMap[currentTab]} getChooseLand={choiceItem} isChoice={isChoice} apeId={apeId} mode={mode}/>
            </Swiper.Item>
          </Swiper>
        </div>
        <div className={styles.confirm_btn_box}>
          <span 
            className={`${styles.confirm_btn} ${styles.active}`} 
            onClick={() => {
              cancelPlace(currentChooseLand)
            }}
          >取消放置</span>
          <span 
            className={`${styles.confirm_btn} ${isChoice ? styles.active: styles.disabled}`}
            onClick={async() => {
              if (!isChoice) {
                return
              }
              onClose()
              const isApeWord = await handleApeWork()
              if (isApeWord) {
                setConfirmVisible(true)
              } else {
                onSelectConfirm()
              }
            }}
          >确认</span>
        </div>
      </div>
    </Popup>
    <Mask
      className={styles.confirm_mask}
      visible={confirmVisible}
    >
      <div className={styles.confirm_container}>
        <div className={styles.header}>
          <span className={styles.close_confirm_mask}></span>
          <span className={styles.title}>更换土地确认</span>
          <img className={styles.close_confirm_mask} src={close} alt="" onClick={() => setConfirmVisible(false)} />
        </div>
        <div className={styles.confirm_tip}>
          无聊猿正在打工，还未完成今天任务，<br />更换土地后没有经验奖励，确认更换？
        </div>
        <div className={styles.btn_box}>
          <div className={styles.cancel_btn} onClick={() => setConfirmVisible(false)}>取消</div>
          <div className={styles.confirm_btn} onClick={onSelectConfirm}>确认</div>
        </div>
      </div>
    </Mask>
  </>
  
}

const LandList = ({focusStatus, getChooseLand, isChoice, apeId, type,mode}) => {
  const [initStatus, setInitStatus] = useState(false)
  const [landData, setLandData] = useState([])
  const [hasMore, setHasMore] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const currentPage = useRef(1);
  const pageSize = useRef(20);

  useEffect(() => {
    if (!initStatus && focusStatus) {
      setInitStatus(true);
      getLandList();
      return;
    }
  }, [initStatus, focusStatus])

  const getLandList = async (isRefresh=true) => {
    try {
      if(isRefresh) {
        currentPage.current = 1;
      } else {
        currentPage.current = currentPage.current + 1;
      }
      const params = {
        pageNum: currentPage.current,
        pageSize: pageSize.current,
        blockLevel: type,
        spaceType: +mode === 3?2:+mode === 2 ? 1 : 0,//空间类型 0农业  1工业  2黄金甲
      }
      console.log(params)
      const res = await placeLandList(params)
      console.log(res)
      if (res.code !== '000000') throw res.msg
      if(currentPage.current === 1) {
        setLandData(res?.data?.landBlocksDTOList || [])
      } else {
        setLandData([...landData, ...res?.data?.landBlocksDTOList]);
      }
      isRefresh && setIsLoad(true);
      setHasMore(res.data.totalCount > [...landData, ...res?.data?.landBlocksDTOList].length);
    } catch (error) {
      console.log(error)
      Toast.show(error)
    }
  }

  const listItem = (item) => {
    return <div 
      className={styles.list_item}
      onClick={() => getChooseLand(item)}
    >
      <div className={styles.list_item_inner}>
        <div className={styles.land_img_box}>
          <img className={styles[StyleMap[item.collectionId]] || ''} 
            src={item.nftImage} alt=""/>
        </div>
        <p>#{item.nftNo}</p>
        <img className={styles.select_img} src={isChoice && item.nftNo === apeId ? xuanzhong: weixuanzhong} alt="" />
        {item.ownFlag === 1 ? <div className={styles.lease_tag}></div>: null}
      </div>
    </div>
  }
  return <div className={styles.land_list}>
    {
      landData?.length > 0 ? <ListView
        dataSource={landData}
        hasMore={hasMore}
        style={{paddingTop: 5}}
        renderItem={listItem}
        onEndReached={async () => {
          await getLandList(false);
        }}
        isLoad={isLoad}
      />: !isLoad ? null: <div className={styles.no_data}><img src={noData} alt="" /></div>
    }
  </div>
}

export default ExchangeLand